import React from 'react';
import './InvestorsResearchEconomySection.css';

const NODE_KEYS = [1, 2, 3, 4, 5, 6];

/**
 * Section 04: conceptual diagram for Labs research economy vision (data → model → inference loop).
 * Copy lives under translations researchEconomy.* — does not replace existing pillar or structure diagrams.
 */
export function InvestorsResearchEconomySection({ t }) {
  return (
    <section
      className="investors-section investors-research-economy"
      aria-labelledby="investors-research-economy-heading"
    >
      <div className="investors-bleed-inner investors-research-economy-inner">
        <span className="investors-section-overline" aria-hidden="true">
          04
        </span>
        <h2 id="investors-research-economy-heading" className="investors-section-title">
          {t('researchEconomy.title', 'Labs vision: contributor-linked data & model economy')}
        </h2>
        <p className="investors-section-subtitle investors-research-economy-intro">
          {t(
            'researchEconomy.intro',
            'B-esper Labs is developing research directions for a marketplace connecting data providers, model builders, and inference consumers.',
          )}
        </p>

        <p className="investors-research-economy-flow-caption" role="note">
          {t('researchEconomy.flowCaption', 'Economic feedback loop from data to deployed inference (vision)')}
        </p>

        <div className="investors-research-economy-diagram">
          <ol className="investors-research-economy-nodes">
            {NODE_KEYS.map((n) => (
              <li key={n} className="investors-research-economy-node">
                <span className="investors-research-economy-node-index">{n}</span>
                <span className="investors-research-economy-node-label">
                  {t(`researchEconomy.node${n}Label`, '')}
                </span>
                <span className="investors-research-economy-node-detail">
                  {t(`researchEconomy.node${n}Detail`, '')}
                </span>
              </li>
            ))}
          </ol>

          <div className="investors-research-economy-arrows" aria-hidden="true">
            <svg className="investors-research-economy-loop-svg" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid meet">
              <defs>
                <linearGradient id="researchEconomyLoopGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="rgba(196, 165, 116, 0.45)" />
                  <stop offset="100%" stopColor="rgba(88, 151, 222, 0.35)" />
                </linearGradient>
              </defs>
              <ellipse
                cx="200"
                cy="200"
                rx="168"
                ry="168"
                fill="none"
                stroke="url(#researchEconomyLoopGrad)"
                strokeWidth="2"
                strokeDasharray="8 10"
                opacity="0.85"
              />
            </svg>
          </div>
        </div>

        <div className="investors-research-economy-trust">
          <h3 className="investors-research-economy-trust-title">
            {t('researchEconomy.trustTitle', 'Trust & auditability')}
          </h3>
          <p className="investors-research-economy-trust-detail">
            {t(
              'researchEconomy.trustDetail',
              'Reproducible training logs and governance so accounting remains verifiable.',
            )}
          </p>
        </div>
      </div>
    </section>
  );
}
